import React, { useRef, useEffect } from "react";
import { gsap } from "gsap";
import { Link } from "react-router-dom";
import "./Hamburger.scss"
import {
  staggerText,
  staggerReveal,
  fadeInUp,
  handleHover,
  handleHoverExit,
  handleCityReturn,
  handleCity,
  staggerRevealClose
} from "./../Animations";
import astronaut from '../../assets/images/waveman2.png'
import planet1 from "../../assets/images/1.png"
import planet2 from "../../assets/images/2.png"
import planet3 from "../../assets/images/3.png"
import planet4 from "../../assets/images/4.png"
import planet5 from "../../assets/images/5.png"

const planetBg =[
  {name:"靛色星",image:planet1},
  {name:"波地球",image:planet2},
  {name:"綠藻星",image:planet3},
  {name:"紫波星",image:planet4},
  {name:"紅柿星",image:planet5},
]

const Hamburger = ({state}) => {
  //dom 變數
  let menu = useRef(null);
  let realMenu = useRef(null);
  let realMenuBackground  = useRef(null);
  let planetBackground = useRef(null);
  let line1 = useRef(null);
  let line2 = useRef(null);
  let line3 = useRef(null);
  let info = useRef(null);

  useEffect(() => {
    // If the menu is open and we click the menu button to close it.
    if (state.clicked === false) {
      // If menu is closed and we want to open it.

      staggerRevealClose(realMenu , realMenuBackground);
      // menu.style.display="none"
      // Set menu to display none
      gsap.to(menu, { duration: 1, css: { display: "none" } })



    } else if (
      state.clicked === true ||
      (state.clicked === true && state.initial === null)
    ) {
      // menu.style.display="block" //flex 不行因為有bg black
      // Set menu to display block
      gsap.to(menu, { duration: 0, css: { display: "block" } });
      //Allow menu to have height of 100%

      gsap.to([realMenuBackground,realMenu ], {
        duration: 0,
        opacity: 1,
        height: "100%"
      });
      staggerReveal([realMenuBackground,realMenu ]);
      fadeInUp(info);
      staggerText(line1, line2,line3);
    }
  }, [state]);

  const handlePlanet = planet=>{
    gsap.to(planetBackground,{
      duration:0,
      background: `url(${planet}) center center`
    })
    gsap.to(planetBackground,{
      duration:.4,
      opacity: 1,
      ease:"power3.inOut"
    })
    gsap.to(planetBackground,{
      duration:.4,
      skeyY: 2,
      //skewY旋轉
      transformOrigin:"right top"
    })
  }
const handlePlanetReturn=()=>{
  gsap.to(planetBackground,{
    duration:.4,
    opacity: 0,
  })
}
//旋轉特效
const handleHover=e=>{
  gsap.to(e.target,{
    duration:.3,
    y:3,
    skewX:4,
    ease:"power3.inOut"
  })
}
//旋轉特效
const handleHoveExit=e=>{
  gsap.to(e.target,{
    duration:.3,
    y:-3,
    skewX:0,
    ease:"power3.inOut"
  })
}


  return (
    <>
      {/* menu-secondary-background-color black那個黑影 之後這邊可以創多一點 */}
      <div ref={el => (menu = el)} className="hamburger-menu">
        <div ref={el => (realMenuBackground = el)} className="menu-secondary-background-color"></div>
        <div ref={el => (realMenu = el)} className="menu-layer">
        <div className="menu-layer-planet">
        {/* menu-planet-background就是city 按了以後會改變背景*/}
          <div ref={el => (planetBackground= el)} className="menu-planet-background">

          </div>
          <div className="container">
            <div className="wrapper">
              <div className="menu-links">
                <nav>
                  <ul>
                    <li>
                      <Link onMouseEnter={e=>handleHover(e)}
                      onMouseOut={e=>handleHoverExit(e)}
                      ref={el => (line1 = el)} to ="/about">宇宙波波的故事</Link>
                      
                    </li>
                    <li>
                      <Link onMouseEnter={e=>handleHover(e)}
                      onMouseOut={e=>handleHoverExit(e)}
                      ref={el => (line2 = el)} to ="/partner">波波的快樂夥伴</Link>
                    </li>
                    <li>
                      <Link 
                      onMouseEnter={e=>handleHover(e)}
                      onMouseOut={e=>handleHoverExit(e)}
                      ref={el => (line3 = el)} to ="/product">波波的周邊商品</Link>
                    </li>
                  </ul>
                </nav>
              <div ref={el => (info = el)} className="info">
              <img src={astronaut} alt="spaceman" />
                <h3>
                  綽號：波波人
                </h3>
                {/* <p>宇宙</p> */}
              </div>
              <div className="charecter">
                    星球：
                    {planetBg.map(el =>(
                      <span key={el.name} onMouseEnter={()=>handlePlanet(el.image)} onMouseOut={handlePlanetReturn}>{el.name}</span>
                    ))}
              </div>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Hamburger
